import './Pagination.scss'

import React from 'react'

import { Button } from '../Button'

const NUM_BUTTONS = 5

const t = {
    PREVIOUS: 'Previous',
    NEXT: 'Next',
}

/**
 * @param {Object} props
 * @param {React.ReactNode} props.children
 * @param {boolean} [props.isCurrent]
 * @param {() => void} props.onClick
 */
const PaginationButton = ({ children, isCurrent, onClick }) => {
    const handleClick = e => {
        e.preventDefault()
        onClick()
    }

    return (
        <Button href="#top" onClick={handleClick} active={isCurrent} width="narrower">
            {children}
        </Button>
    )
}

/**
 * @param {Object} props
 * @param {number} props.page
 * @param {number} props.numPages
 * @param {(page: number) => void} props.onChange
 */
const Pagination = ({ page, numPages, onChange }) => {
    if (numPages < 2) return null

    let offset = page - Math.floor(NUM_BUTTONS / 2)
    const maxOffset = numPages + 1 - NUM_BUTTONS
    if (offset > maxOffset) {
        offset = maxOffset
    }
    const buttonsOffset = (offset < 1) ? 1 : offset
    const numButtons = Math.min(NUM_BUTTONS, numPages)
    const pageItems = Array.from(Array(numButtons).keys()).map(i => {
        const number = buttonsOffset + i
        const isCurrent = number === page
        return (
            <li key={i}>
                <PaginationButton isCurrent={isCurrent} onClick={() => onChange(number)}>
                    {number}
                </PaginationButton>
            </li>
        )
    })

    return (
        <ul className="pagination">
            {(page > 2) && (
                <li>
                    <PaginationButton onClick={() => onChange(page - 1)}>
                        <i className="i-caret-left" title={t.PREVIOUS}></i>
                    </PaginationButton>
                </li>
            )}
            {(page > Math.ceil(NUM_BUTTONS / 2)) && (
                <li className="pagination-placeholder">...</li>
            )}
            {pageItems}
            {(numPages - page > Math.floor(NUM_BUTTONS / 2)) && (
                <li className="pagination-placeholder">...</li>
            )}
            {(page < numPages - 1) && (
                <li>
                    <PaginationButton onClick={() => onChange(page + 1)}>
                        <i className="i-caret-right" title={t.NEXT}></i>
                    </PaginationButton>
                </li>
            )}
        </ul>
    )
}

export default Pagination
